'use strict';

// Constructor
var TitleBar = function () {

    var $url;

    $('.share-page a').click(function () {

        console.log(encodeURIComponent(window.location.origin + window.location.pathname));

        if ($(this).hasClass('facebook')) {
            $url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.origin + window.location.pathname);
        } else if ($(this).hasClass('twitter')) {
            $url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(window.location.origin + window.location.pathname) + '&text=' + $('.title-bar h2').text();
        } else if ($(this).hasClass('print')) {
            window.print();
            return true;
        } else if ($(this).hasClass('email')) {
            $url =  'mailto:?subject=' + $('.title-bar h2').text() + '&body=' + window.location.origin + window.location.pathname;
        }

        var height = 300;
        var width = 500;
        var left = (screen.width / 2) - (width / 2);
        var top = (screen.height / 2) - (height / 2);

        window.open($url, "", "menubar=no, toolbar=no, resizable=yes, scrollbars=yes, width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
        return true;
    })
};

module.exports = TitleBar;
